import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'cmps-report-builder-selection-section',
    templateUrl: './section.component.html',
})
export class SectionComponent {
    @Input() noSelect: boolean;
    @Input() selected: boolean;
    @Output() click: EventEmitter<void>;

    constructor() {
        this.click = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.click.complete();
    }
}
